import * as React from 'react';
import * as $ from 'jquery';
import * as _ from 'underscore';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import * as reactGlobalClick from '../ts/reactGlobalClick';
import { IPopupOptions } from '../../../pdc-platform/src/ts/actions/DialogActions';
import { IValuesCollection } from '../ts/appTheme';
import { getSelectedItemStyle } from './selectors/SelectedItem';

const webfontloader = require('pdc-platform-webfontloader');

const SEARCH_FIELD_HEIGHT = 21;
const VIEW_FRAME_SIZE = 298 - SEARCH_FIELD_HEIGHT;
const VIEW_FRAME_PADDING = 5;
const ELEMENT_MARGIN = 2;
const ELEMENT_SIZE = 60;
const HEIGHT_MARGIN = ELEMENT_MARGIN + VIEW_FRAME_PADDING + SEARCH_FIELD_HEIGHT;
const THRESHOLD_FRAME = 20;

function Font(props: {
    visible: boolean;
    selected: boolean;
    obj: {
        family: string;
        searchParts: string[];
    };

    onSelect(family: string): void;
}) {
    const [loading, setLoading] = React.useState(false);

    const fontLoaded = React.useRef(false);

    React.useEffect(() => {
        if (props.visible && !fontLoaded.current) {
            fontLoaded.current = true;

            setLoading(true);

            const def = $.Deferred<boolean>();

            webfontloader.load({
                google: {
                    families: [props.obj.family]
                },
                text: 'Lorem ipsum dolor sit amet',
                classes: false,

                active: () => {
                    def.resolve(true);
                },

                inactive: () => {
                    def.resolve(false);
                }
            });

            def.done((value) => {
                setLoading(false);
            });

            return () => {
                def.reject();
            };
        }
    }, [props.visible, props.obj.family]);

    const handleOnSelect = (e) => {
        if (typeof props.onSelect === 'function') {
            props.onSelect(props.obj.family);
        }
    };

    let content;

    if (!loading) {
        content = (
            <div
                className="font-example"
                style={{
                    fontFamily: "'" + props.obj.family + "'"
                }}
            >
                {'Lorem ipsum dolor sit amet'}
            </div>
        );
    }

    return (
        <li
            className={
                'dropdown-item font-element' +
                (props.visible ? ' font-element-visible' : '') +
                (loading ? ' font-element-loading' : '')
            }
        >
            <div className="font-name">
                <input type="checkbox" checked={props.selected} onChange={handleOnSelect} />
                <span>{props.obj.searchParts[0]}</span>
                <span className="highlighted-search">{props.obj.searchParts[1]}</span>
                <span>{props.obj.searchParts[2]}</span>
            </div>

            {content}
        </li>
    );
}

function searchForFilters(search: string, fonts) {
    return _.filter(fonts, (obj) => {
        const str = obj.family.toLowerCase();
        const index = str.indexOf(search);

        if (index === -1) {
            return false;
        }

        obj.searchParts = [
            obj.family.slice(0, index),
            obj.family.slice(index, index + search.length),
            obj.family.slice(index + search.length)
        ];

        return true;
    });
}

interface IVisibleIndexes {
    threshold?;
    visibleStart?: number;
    visibleEnd?: number;
}

function calcVisibleIndexes(scroll, filtered, threshold: number) {
    const start = Math.ceil((scroll - ELEMENT_SIZE - HEIGHT_MARGIN) / (ELEMENT_SIZE + ELEMENT_MARGIN));

    const end = Math.floor((scroll + VIEW_FRAME_SIZE - HEIGHT_MARGIN) / (ELEMENT_SIZE + ELEMENT_MARGIN));

    const result: IVisibleIndexes = {
        visibleStart: Math.max(0, start),
        visibleEnd: Math.min(filtered.length - 1, end)
    };

    if (result.visibleEnd === threshold) {
        result.threshold = Math.min(filtered.length - 1, threshold + THRESHOLD_FRAME);
    }

    return result;
}

interface IFontDropdownOptions extends IPopupOptions {
    value;
    fonts;
    height: number;
    width: number;

    updateState?(state);
    onClose?(): void;
    onChange?(value): void;
}

interface IFontDropdownState extends IVisibleIndexes {
    value;
    searchText: string;
    fonts;
    scrollTop: number;
    height: number;
    width: number;
    containerHeight: number;
    filtered?;
    searchFieldIsfocused: boolean;
}

class FontDropdown extends React.Component<
    {
        zIndex: number;
        options: IFontDropdownOptions;
        glob: IGlob;

        close(): void;
    },
    IFontDropdownState
> {
    private references: {
        container?: HTMLDivElement;
        suggestionsList?: HTMLDivElement;
    } = {};
    private globalClickIndex = -1;

    constructor(props) {
        super(props);

        const options = this.props.options;
        const obj: IFontDropdownState = {
            searchText: '',
            fonts: options.fonts,
            value: options.value,
            height: options.height,
            width: options.width,
            containerHeight: VIEW_FRAME_SIZE,
            scrollTop: 0,
            threshold: THRESHOLD_FRAME,
            searchFieldIsfocused: false
        };

        obj.filtered = searchForFilters(obj.searchText, obj.fonts);

        this.state = _.extend(obj, calcVisibleIndexes(0, obj.filtered, obj.threshold));
    }

    componentDidMount() {
        this.props.options.updateState(this.updateState);

        this.globalClickIndex = reactGlobalClick.register((e) => {
            this.globalClick();
        }, 1);
        this.handleWindowResize();
        $(window).on('resize', this.handleWindowResize);
    }

    componentWillUnmount() {
        this.globalClick();

        reactGlobalClick.unregister(this.globalClickIndex);
        delete this.globalClickIndex;
        $(window).off('resize', this.handleWindowResize);
    }

    handleWindowResize = () => {
        const suggestionslist = this.references.suggestionsList;

        if (suggestionslist.parentNode != null) {
            const containerHeight = (suggestionslist.parentNode as any).clientHeight;

            if (containerHeight > 0 && containerHeight != this.state.containerHeight) {
                this.setState({
                    containerHeight: containerHeight
                });
            }
        }
    };

    updateState = (obj) => {
        if (obj.search != null && obj.search !== this.state.searchText) {
            obj.filtered = searchForFilters(obj.search, this.state.fonts);
        }

        try {
            this.setState(obj);
        } catch (e) {}
    };

    globalClick = () => {
        if (this.state.searchFieldIsfocused) {
            return;
        }

        if (typeof this.props.options.onClose === 'function') {
            this.props.options.onClose();
        }

        this.props.close();
    };

    componentDidUpdate(e) {
        const scrollTop = this.references.container.scrollTop;

        if (this.state.scrollTop !== scrollTop) {
            this.handleScroll(e);
        }
    }

    handleScroll = _.throttle((e) => {
        if (this.references.container == null) {
            return;
        }

        const scrollTop = this.references.container.scrollTop;

        this.setState(
            _.extend(
                {
                    scrollTop: scrollTop
                },
                calcVisibleIndexes(scrollTop, this.state.filtered, this.state.threshold)
            )
        );
    }, 300);

    handleSelect = (value) => {
        this.setState({
            value: value
        });

        if (typeof this.props.options.onChange === 'function') {
            this.props.options.onChange(value);
        }
    };

    handleOnContainerClick = (e) => {
        reactGlobalClick.cancel();
    };

    handleOnSearchClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        reactGlobalClick.cancel();
    };

    handleOnSearchChange = (e) => {
        const newValue = e.target.value;
        const newFiltered = searchForFilters(newValue, this.state.fonts);

        this.setState({
            searchText: newValue,
            filtered: newFiltered,
            ...calcVisibleIndexes(0, newFiltered, THRESHOLD_FRAME)
        });
    };

    handleOnSearchFocus = (e) => {
        e.stopPropagation();
        e.preventDefault();
        reactGlobalClick.cancel();
        this.setState({ searchFieldIsfocused: true });
    };

    handleOnSearchBlur = () => {
        this.setState({ searchFieldIsfocused: false });
    };

    render() {
        const content = _.map(this.state.filtered.slice(0, this.state.threshold), (obj, i) => {
            return (
                <Font
                    key={obj.family}
                    obj={obj}
                    selected={this.state.value === obj.family}
                    visible={this.state.visibleStart <= i && this.state.visibleEnd >= i}
                    onSelect={this.handleSelect}
                />
            );
        });

        const height = this.state.containerHeight - HEIGHT_MARGIN;

        return (
            <div
                className={'fonts-select suggestions-list'}
                ref={(input) => {
                    this.references.suggestionsList = input;
                }}
                onClick={this.handleOnContainerClick}
            >
                <div className="w-100">
                    <input
                        name="search-field"
                        className="w-100"
                        type="text"
                        value={this.state.searchText}
                        placeholder={'Search for font'}
                        onClick={this.handleOnSearchClick}
                        onInput={this.handleOnSearchChange}
                        onFocus={this.handleOnSearchFocus}
                        onBlur={this.handleOnSearchBlur}
                        onChange={() => {}} // To fix a red warning.
                    />
                </div>
                <div onClick={this.handleOnContainerClick}>
                    <div
                        ref={(input) => {
                            this.references.container = input;
                        }}
                        className="fonts-select-container"
                        style={{ height: height + 'px', overflow: 'scroll' }}
                        onScroll={this.handleScroll}
                    >
                        {content}
                    </div>
                </div>
            </div>
        );
    }
}

export function FontField(props: {
    value;
    glob: IGlob;
    theme: IValuesCollection;

    onChange(value): void;
}) {
    const storeState = props.glob.FontsStore.useSimpleStoreStateHook();

    const [dropdownVisible, setDropdownVisible] = React.useState(false);

    const searchContainer = React.useRef<HTMLDivElement>(null);
    const updateDropdownState = React.useRef<(obj) => void>(null);

    React.useEffect(() => {
        props.glob.FontsActions.loadFonts();
    }, []);

    const handleOnChange = React.useCallback(
        (value) => {
            if (typeof props.onChange === 'function') {
                props.onChange(value);
            }
        },
        [props.onChange]
    );

    const handleOnClose = React.useCallback(() => {
        setDropdownVisible(false);
    }, []);

    const dropdownStateUpdateHook = React.useCallback((callback) => {
        updateDropdownState.current = (obj) => {
            callback(obj);
        };
    }, []);

    const handleOnClick = (e) => {
        reactGlobalClick.trigger(e, 1);
        reactGlobalClick.cancel();

        if (dropdownVisible) {
            return;
        }

        const searchContainerElement = $(searchContainer.current);
        const offset = searchContainerElement.offset();

        props.glob.DialogActions.createPopup<IFontDropdownOptions>('', {
            top: offset.top,
            left: offset.left,
            width: searchContainerElement.outerWidth(),
            height: searchContainerElement.outerHeight(),
            value: props.value,
            fonts: storeState.fonts,
            onChange: handleOnChange,
            onClose: handleOnClose,
            updateState: dropdownStateUpdateHook,

            component: FontDropdown
        });

        setDropdownVisible(true);

        e.stopPropagation();
        e.preventDefault();
    };

    let content: React.JSX.Element;

    if (props.value != null) {
        const itemStyle = getSelectedItemStyle(props.theme);

        content = (
            <li key={props.value} className="pull-left label-value" style={itemStyle}>
                <span>{props.value}</span>
            </li>
        );
    }

    return (
        <div className="suggestion-select" onClick={handleOnClick}>
            <div className="search-field-group form-control" ref={searchContainer}>
                <ul className="list-unstyled item-selector-values-list">{content}</ul>
            </div>
        </div>
    );
}
